import React from 'react'
import { Content, Footer, Header, Navigation } from '../../components'

export const GameScreen: React.FC = () => {
  return (
    <React.Fragment>
      <Header />
      <Content />
      <Footer />
      <Navigation />
    </React.Fragment>
  )
}
